export default class DailyClosingController {
  constructor(ContentService, $state, moment) {
    this.service = ContentService;
    this.state = $state;
    this.moment = moment
  }

  $onInit() {
    this.subscriptions = [];

    this.customerData = null;
    this.rows = [];
    this.topArticle = '';
    this.topCashier = '';
    this.reportParams = {
      date_to: undefined
    };
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  findReport() {
    this.subscriptions.push(
      this.service.findClosingHourReport({
        date_to: this.reportParams.date_to.toISOString()
      }).subscribe(
        data => { this.rows = data.sales; this.topArticle = data.top_product; this.topCashier = data.top_cashier; this.customerData = data.customers; this.calculateTotals(data.sales);}
      )
    );
  }

  calculateTotals(sales){
    let todayTotal = sales.filter(x => !!x.today).reduce((x, y) => {
      return {today: x.today + y.today};
    }).today;
    this.todayTotal = todayTotal;
    let mtdTotal = sales.filter(x => !!x.mtd).reduce((x, y) => {
      return {mtd: x.mtd + y.mtd};
    }).mtd;
    this.mtdTotal = mtdTotal;
  }

}

DailyClosingController.$inject = ['ContentService', '$state', 'moment'];



// WEBPACK FOOTER //
// ./src/app/pages/daily-closing/daily-closing.controller.js